export default __webpack_public_path__ + "static/media/theme.1379906b.svg";